






import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class NavTitle extends Vue {
  @Prop({ default: '未輸入標題' }) private title!: string;
}
